import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import IndustriesBanner from "../../components/pages/Industries/IndustriesBanner/IndustriesBanner";
import Challenges from "../../components/pages/Industries/Challenges/Challenges";
import WhatWeBuild from "../../components/pages/Industries/WhatWeBuild/WhatWeBuild";
import RelevantServices from "../../components/pages/Industries/RelevantServices/RelevantServices";
import WhyUs from "../../components/pages/Home/WhyUs/WhyUs";
import Enables from "../../components/pages/Industries/Enables/Enables";
import Need from "../../components/pages/Industries/Need/Need";

export default function IndustryPageLayout() {
  return (
    <div>
      <Navbar />
      <IndustriesBanner />
      <Challenges />
      <WhatWeBuild />
      <RelevantServices />
      <WhyUs />
      <Enables />
      <Need />
      <Footer />
    </div>
  );
}
